export const EstadoCertificadoDigital=Object.freeze({
     EXPIRADO:"EXPIRADO",
     NO_EXPIRADO:"NO_EXPIRADO",
     NO_CERTIFICADO:"NO_CERTIFICADO"// NO TIENE CERTIFICADO

});